import styled from "@emotion/styled";
import { units } from "../../../../types/units";

export const RemoveButton = styled.button`
  padding: 0;
  justify-self: flex-end;
  border: none;
  background: none;
  cursor: pointer;
  font-family: ${(props) => props.theme.fontFamily.primary};
  ${units({
    fontSize: "text",
  })};
`;
